export default __webpack_public_path__ + "static/media/transparent.07bbb169.png";